import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public readonly LOCATION = environment.apiUrl;
  public readonly APPLICATION: string = "Fejlmelding";
  public readonly PLATFORM: string = "Browser";

  public readonly CONFIRM_PASSWORD_REQUEST = this.LOCATION + "/verify-mobile-request";
  
  public readonly GET_CONNECTION_STRINGS = this.LOCATION + "/connection-strings"

  constructor() { }
}
